module.exports = __webpack_public_path__ + "static/media/b1.a7e1c66e.jpg";